
import { startaScreenModel } from '../../models/model';
import { actionTypes } from '../action/action';

const initialState = {
  startingScreenLoader: false,
  locationName:''
};

export const startingScreenReducer = (state:startaScreenModel  = initialState, action: any) => {
  switch (action.type) {
   
    case actionTypes.STARTING_SCREEN:
      return{
        ...state, startingScreenLoader: action.payload.startingScreenLoader,
        locationName: action.payload.locationName
      };

  default:
    return state;
  }
};